import React from 'react';

import PaymentOptionItem from './PaymentOptionItem';
import styles from './PaymentOptionStyles.module.css';
import { PromoText } from '../common/promo-text/PromoText';

const PaymentOptionContent = (props) => {
    return (
        <ul className={styles.paymentOptionContentList}>
            {Object.entries(props.paymentGroup).map(([key, value]) => (
                <li key={key}>
                    <PaymentOptionItem key={key} items={value} />
                </li>
            ))}
            {props.settlement?.title && (
                <li>
                    <div className={styles.paymentOptionItem}>
                        <div className={`${styles.paymentOptionRow} ${styles.paymentOptionRowShort}`}>
                            <PromoText color={'white'} isBold>
                                {props.settlement?.title}
                            </PromoText>
                        </div>
                        <PromoText color={'white'}>{props.settlement?.description}</PromoText>
                    </div>
                </li>
            )}
        </ul>
    );
};
export default PaymentOptionContent;
